<template>
    <vue-tailwind-datepicker :class="classes" :disable-date="dDate" :start-from="startFrom" v-slot="{ value, placeholder, clear }">
        <button type="flex flex-nowrap items-center" class="flex flex-col lg:flex-row mx-auto lg:mx-0 focus:outline-none">
            <span class="flex-1 flex-nowrap text-gray-300 hover:text-gray-100 mx-auto ">
                <svg class="inline px-0 py-1.5 bg-cover bg-center bg-no-repeat w-[2.8rem] h-[2.8rem] rounded-full bg-gray-700 leading-6 border-2 border-gray-500 hover:border-gray-100 transition ease-out duration-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-4 -4 32 32" stroke="currentColor" width="2.3em" height="2.3em">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
            </span>
            
            <p class="text-gray-300 hover:text-gray-100 shrink inline font-semibold text-xs lg:text-sm p-1 mx-2 my-auto">
                {{ shortenDate(value) || placeholder }}
            </p>
        </button>
    </vue-tailwind-datepicker>
</template>
<script>
import { ref, onMounted, computed, watch } from 'vue';
import VueTailwindDatepicker from 'vue-tailwind-datepicker';
import { useStore } from 'vuex';
import { CalendarIcon } from "@heroicons/vue/outline";

export default {
    props: {
        classes: {
            type: String,
            default: '',
        },
        registration: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        VueTailwindDatepicker
    },

    methods: {
        shortenDate(date) {
            return date.substring(0, 6) + date.substring(8, 10);
        }
    },

    setup(props, { emit }) {

        const store = useStore()

        const datePicker = ref(null)

        const windowWidth = ref(window.innerWidth)

        const overEighteen = (date) => {
            let ageDifMs = Date.now() - date.getTime()
            let ageDate = new Date(ageDifMs)
            let age = Math.abs(ageDate.getUTCFullYear() - 1970)

            if (age > 17) {
                return true
            } else {
                return false
            }
        }

        const dDate = (date) => {
            if (props.registration) {
                return !overEighteen(date)
            }

            return date > new Date().addDays(1)
        }

        const startFrom = computed(() => {
            if (props.registration) {
                let today = new Date()
                let dd = today.getDate()
                let mm = today.getMonth() + 1 //January is 0!
                let yyyy = today.getFullYear() - 18

                if (dd < 10) {
                    dd = '0' + dd
                } 
                if (mm < 10) {
                    mm = '0' + mm
                }

                return new Date(mm + '/' + dd + '/' + yyyy)
            }

            return new Date()
        })

        const isMobile = computed(() => {
            return windowWidth.value < 640
        })

        const setWindowWidth = () => {
            windowWidth.value = window.innerWidth

            if (datePicker.value) {
                if (isMobile.value && route().current() !== 'welcome' && isMobile.value && route().current() !== 'register') {
                    datePicker.value.LitepieRef.children[0].style.marginTop = '63px'
                } else {
                    datePicker.value.LitepieRef.children[0].style.marginTop = '0'
                }
            }
        }

        const open = computed(() => {
            if (datePicker.value) {
                return datePicker.value.isShow
            }

            return false
        })

        onMounted(() => {
            setWindowWidth()

            window.addEventListener('resize', setWindowWidth)
        })

        watch(open, (currentValue, oldValue) => {
            if (isMobile) {
                store.commit('toggleDatePicker', currentValue)
            }
        })

        // const removeFocus = () => {
        //     let input = datePicker.value.LitepieInputRef
            
        //     input.blur()
        // }

        return {
            datePicker,
            // removeFocus,
            dDate,
            startFrom,
            isMobile,
            CalendarIcon,
        }
    }
}

</script>
